export const WARNING_TIME_IN_MIN = 3;
export const DANGER_TIME_IN_MIN = 6;
export const URGENCY_TIME_IN_MIN = 8;
